import { useAuth } from '../contexts/AuthContext';

/**
 * Custom hook for checking permissions in components
 * @param {string|string[]} module - The module name(s), e.g. "Order Details" or ["Order Details", "finance/orderinvoices"]
 * @returns {object} Permission check functions
 */
export const usePermissions = (module) => {
  const { hasPermission, canAccessModule } = useAuth();
  const modules = Array.isArray(module) ? module : [module];

  return {
    canCreate: modules.some((m) => hasPermission(m, 'CREATE')),
    canRead: modules.some((m) => hasPermission(m, 'READ')),
    canUpdate: modules.some((m) => hasPermission(m, 'UPDATE')),
    canDelete: modules.some((m) => hasPermission(m, 'DELETE')),
    canManage: modules.some((m) => hasPermission(m, 'MANAGE')),
    canAccess: modules.some((m) => canAccessModule(m)),
    hasPermission: (action) => modules.some((m) => hasPermission(m, action)),
  };
};
